import {getData} from "./api/get-data";
import {showRespectModal} from "./controllers/offer-controller";
import {createBlockquote} from "./create/create-blockquote";
import {createButton} from "./create/create-button";
import {createCite} from "./create/create-cite";
import {createCounterElement} from "./create/create-counter";
import {createDiv} from "./create/create-div";
import {createImage} from "./create/create-image";
import {createList} from "./create/create-list";
import {createListItem} from "./create/create-list-item";
import {createParagraph} from "./create/create-paragraph";
import {createSpan} from "./create/create-span";
import {createSvg} from "./create/create-svg";
// import {createTableRow} from "./create/create-table-row";
import {showOfferPopup} from "./show-offer-popup";
import {getFormattedPrice} from "./utils/get-formatted-price";
import {getBonusNumeralEnding, getReviewNumeralEnding} from "./utils/get-numeral-ending";
import {isEmptyObject} from "./utils/is-empty-object";
import {isInteger} from "./utils/is-integer";
import Swiper from 'swiper';
import {Keyboard, Navigation, Pagination, Thumbs} from 'swiper/modules';
import FavoritesController from "./controllers/favorites";
import {render, RenderPosition} from "./utils/render";
import LabelsController from "./controllers/labels";
import {getProductData} from "./parsing/product";
import {renderAccessories} from "./render-accessories";
import PropertyProductTableComponent from "./components/property-product-table";
import ModsComponent from "./components/mods";
import {setPriceInc} from "./require/set-price";

const onEscPressPopupHandler = (evt) => {
  if (evt.key === `Escape`) {
    const popupElements = document.querySelectorAll(`.popup--show`);

    popupElements.forEach((elem) => {
      elem.classList.remove(`popup`, `popup--show`);
      // centerHeaderElement.classList.remove(`main-header__center--popup`);
      document.removeEventListener(`keydown`, onEscPressPopupHandler);
      document.querySelector(`body`).classList.remove(`overflowHidden`);
    });
  }
};

const renderMods = (container, currentItemId, mods) => {
  const colorMod = mods[100];
  delete mods[100];

  if (colorMod) {
    const colorModsComponent = new ModsComponent({
      mod: colorMod,
      currentItemId,
      isColor: true
    });

    render(container, colorModsComponent.getElement(), RenderPosition.BEFOREEND);
  }

  Object.keys(mods).forEach((id) => {
    const mod = mods[id];

    const modsComponent = new ModsComponent({
      mod,
      currentItemId,
    });

    render(container, modsComponent.getElement(), RenderPosition.BEFOREEND);
  });
};


export const initProductPage = (shopInfoData, itemData) => {
  const productPageElement = document.querySelector(`.product-page`);
  const product = getProductData(itemData);

  const switchSpec = (spec) => {
    const activeNavTabs = productPageElement.querySelectorAll(`.product-page__navTab--active`);
    activeNavTabs.forEach((tab) => tab.classList.remove(`product-page__navTab--active`));

    const specTab = productPageElement.querySelector(`.product-page__navTab[data-spec="${spec}"]`);
    specTab.classList.add(`product-page__navTab--active`);

    const activeSpecWraps = productPageElement.querySelectorAll(`.product-page__spec--active`);
    activeSpecWraps.forEach((wrap) => wrap.classList.remove(`product-page__spec--active`));

    const specWrap = productPageElement.querySelector(`.product-page__spec[data-spec="${spec}"]`);
    specWrap.classList.add(`product-page__spec--active`);
  };

  const renderReview = (container, review) => {
    const blockquoteElement = createBlockquote(`reviews__blockquote`);
    container.append(blockquoteElement);

    const authorWrapElement = createDiv(`reviews__authorWrap`);
    blockquoteElement.append(authorWrapElement);

    const authorImageElement = createImage(`reviews__authorImg`, review.ava, review.author);
    authorImageElement.width = `50`;
    authorImageElement.height = `50`;
    authorWrapElement.append(authorImageElement);

    const authorTitleElement = createCite(`reviews__author`, review.author);
    authorWrapElement.append(authorTitleElement);

    const authorRatingElement = createDiv(`reviews__authorRating`);
    authorWrapElement.append(authorRatingElement);

    const starSvg = createSvg(``, `20`, `20`, `sienge/img/sprite.svg#icon-star`);
    authorRatingElement.append(starSvg);

    const authorRatingTextElement = createSpan(``, review.rate);
    authorRatingElement.append(authorRatingTextElement);

    // переделать на time
    const dateElement = createSpan(`reviews__date`, review.date);
    authorWrapElement.append(dateElement);

    const reviewContentListElement = createList(`reviews__contentList`);
    blockquoteElement.append(reviewContentListElement);

    if (review.dost) {
      const reviewContentItemElement = createListItem(`reviews__contentItem`);
      reviewContentListElement.append(reviewContentItemElement);

      const titleReviewContentElement = createParagraph(`reviews__contentTitle`, `Достоинства`);
      reviewContentItemElement.append(titleReviewContentElement);

      const textReviewContentElement = createParagraph(``, review.dost);
      reviewContentItemElement.append(textReviewContentElement);
    }

    if (review.nedost) {
      const reviewContentItemElement = createListItem(`reviews__contentItem`);
      reviewContentListElement.append(reviewContentItemElement);

      const titleReviewContentElement = createParagraph(`reviews__contentTitle`, `Недостатки`);
      reviewContentItemElement.append(titleReviewContentElement);

      const textReviewContentElement = createParagraph(``, review.nedost);
      reviewContentItemElement.append(textReviewContentElement);
    }

    if (review.text) {
      const reviewContentItemElement = createListItem(`reviews__contentItem`);
      reviewContentListElement.append(reviewContentItemElement);

      const titleReviewContentElement = createParagraph(`reviews__contentTitle`, `Комментарий`);
      reviewContentItemElement.append(titleReviewContentElement);

      const textReviewContentElement = createParagraph(``, review.text);
      reviewContentItemElement.append(textReviewContentElement);
    }

    // const reviewRatingWrapElement = createDiv(`reviews__reviewRating`);
    // blockquoteElement.append(reviewRatingWrapElement);

    // const reviewRatingUpElement = createDiv(`reviews__authorRating`);
    // reviewRatingWrapElement.append(reviewRatingUpElement);

    // const upSvg = createSvg(``, `20`, `20`, `sienge/img/sprite.svg#icon-thumb-up`);
    // reviewRatingUpElement.append(upSvg);

    // const reviewRatingUpTextElement = createSpan(``, review.yes);
    // reviewRatingUpElement.append(reviewRatingUpTextElement);

    // const reviewRatingDownElement = createDiv(`reviews__authorRating`);
    // reviewRatingWrapElement.append(reviewRatingDownElement);

    // const downSvg = createSvg(``, `20`, `20`, `sienge/img/sprite.svg#icon-thumb-up`);
    // reviewRatingDownElement.append(downSvg);

    // const reviewRatingDownTextElement = createSpan(``, review.no);
    // reviewRatingDownElement.append(reviewRatingDownTextElement);
  };

  const navTabs = productPageElement.querySelectorAll(`.product-page__navTab`);

  navTabs.forEach((tab) => {
    tab.addEventListener(`click`, () => {
      if (tab.classList.contains(`product-page__navTab--active`)) {
        return;
      }
      switchSpec(tab.dataset.spec);
    });
  });

  const parametersAllSpecButton = productPageElement.querySelector(`.product-page__allSpecButton--parameters`);
  if (parametersAllSpecButton) {
    parametersAllSpecButton.addEventListener(`click`, () => switchSpec(`parameters`));
  }

  const reviewsAllSpecButton = productPageElement.querySelector(`.product-page__allSpecButton--reviews`);
  if (reviewsAllSpecButton) {
    reviewsAllSpecButton.addEventListener(`click`, () => switchSpec(`reviews`));
  }

  const commentButtonElement = productPageElement.querySelector(`.product-page__comment`);
  if (commentButtonElement) {
    commentButtonElement.addEventListener(`click`, () => switchSpec(`reviews`));
  }

  const offerPriceButton = productPageElement.querySelector(`.product-page__offerPriceButton`);
  if (offerPriceButton) {
    offerPriceButton.addEventListener(`click`, () => {
      showOfferPopup();
    });
  }


  const informFormElement = productPageElement.querySelector(`.product-page__informForm`);
  const informProductButton = informFormElement.querySelector(`.product-page__informButton`);
  const informTextElement = informFormElement.querySelector(`.product-page__informMessage`);

  informProductButton.addEventListener(`click`, () => {
    informFormElement.dataset.mode = `progress`;
    informTextElement.textContent = ``;

    const phoneInput = informFormElement.querySelector(`.product-page__informInput`);

    getData({
      [`set_item_wait`]: {
        [`item_id`]: itemData.item_id,
        [`phone`]: phoneInput.value,
      }
    })
    .then((response) => {
      if (response.result === `OK`) {
        showRespectModal(`Ваш запрос получен`);
      }

      if (response.result === `ERROR`) {
        informTextElement.textContent = response.error;
      }
    })
    .finally(() => {
      informFormElement.dataset.mode = `input`;
    });
  });

  const wrapImageElement = productPageElement.querySelector(`.product-page__wrapImg`);
  const imageListElement = productPageElement.querySelector(`.product-page__imageList`);
  const previewListElement = productPageElement.querySelector(`.product-page__previewList`);

  Object.keys(itemData.item_images).forEach((key) => {
    const image = itemData.item_images[key];

    const imageItemElement = createListItem(`product-page__imageItem swiper-slide`);
    imageListElement.append(imageItemElement);

    imageItemElement.addEventListener(`click`, () => {
      // открытие попапа
      wrapImageElement.classList.add(`popup`, `popup--show`);
      document.addEventListener(`keydown`, onEscPressPopupHandler);
      document.querySelector(`body`).classList.add(`overflowHidden`);
    });

    const imageElement = createImage(`product-page__image`, image.link, itemData.item_name);
    imageItemElement.append(imageElement);

    if (document.documentElement.clientWidth > 1000) {

      const previewItemElement = createListItem(`product-page__previewItem swiper-slide`);
      previewListElement.append(previewItemElement);

      const previewElement = createParagraph(`product-page__preview`);
      previewItemElement.append(previewElement);

      const previewImageElement = createImage(``, image.prev, itemData.item_name);
      previewElement.append(previewImageElement);
    }
  });

  // servicesSectionElement.dataset.mode = document.documentElement.clientWidth > 1000 ? `show` : `hide`;
  let previewSwiper = null;

  if (document.documentElement.clientWidth > 1000) {
    const wrapPreviewElement = productPageElement.querySelector(`.product-page__wrapPreview`);

    previewSwiper = new Swiper(`.product-page__previewSwiper`, {
      modules: [Navigation],
      spaceBetween: 20,
      watchSlidesProgress: true,
      slidesPerView: 5,
      navigation: {
        nextEl: wrapPreviewElement.querySelector(`.swiper__button--next`),
        prevEl: wrapPreviewElement.querySelector(`.swiper__button--prev`),
        hiddenClass: `product-page__swiperButton--hidden`,
        disabledClass: `product-page__swiperButton--disabled`,
        lockClass: `product-page__swiperButton--lock`
      },
    });

  }

  const imageSwiper = new Swiper(`.product-page__wrapImage`, {
    modules: [Navigation, Pagination, Thumbs, Keyboard],
    lazy: true,
    loop: true,
    slidesPerView: 1,

    keyboard: {
      enabled: true,
    },

    navigation: {
      nextEl: wrapImageElement.querySelector(`.swiper__button--next`),
      prevEl: wrapImageElement.querySelector(`.swiper__button--prev`),
      hiddenClass: `product-page__swiperButton--hidden`,
      disabledClass: `product-page__swiperButton--disabled`,
      lockClass: `product-page__swiperButton--lock`
    },

    pagination: {
      el: `.product-page__swiperPagination`,
    },

    thumbs: {
      swiper: previewSwiper,
      slideThumbActiveClass: `product-page__previewItem--active`,
    },
  });

  new LabelsController({
    className: `product-page`,
    labels: product.labels,
    itemId: product.itemId,
  }).render(productPageElement.querySelector(`.product-page__labelWrap`));

  const itemTitle = productPageElement.querySelector(`.product-page__title`);
  itemTitle.textContent = itemData.item_name;

  const itemRating = productPageElement.querySelector(`.product-page__rating span`);
  itemRating.textContent = itemData.item_rating;

  const itemComment = productPageElement.querySelector(`.product-page__comment span`);
  itemComment.innerHTML = getReviewNumeralEnding(itemData.item_comment_count);


  const itemId = productPageElement.querySelector(`.product-page__id`);
  itemId.textContent = `Код товара: ${itemData.item_id}`;

  if (itemData.seller_profit) {
    const profitElement = productPageElement.querySelector(`.product-page__sellerProfit`);
    profitElement.textContent = `[${itemData.seller_profit}]`;
  }

  // варианты товара
  // product-page__variant
  if (itemData.item_mods) {
    const modsElement = productPageElement.querySelector(`.product-page__mods`);
    renderMods(modsElement, itemData.item_id, itemData.item_mods);
  }

  if (itemData.item_act) {
    const inStockWrap = productPageElement.querySelector(`.product-page__isStock`);
    inStockWrap.dataset.show = `true`;

    const priceWrapElement = productPageElement.querySelector(`.product-page__priceWrap`);

    if (itemData.item_bonus) {
      const paragraphElement = createParagraph(`product-page__bonus`, `+${getBonusNumeralEnding(itemData.item_bonus)}`);
      priceWrapElement.prepend(paragraphElement);
    }

    if (itemData.item_price_old && itemData.item_price_old !== itemData.item_price) {
      const paragraphElement = createParagraph(`product-page__oldPrice`, `${itemData.item_price_old} <span>&#8381;</span>`);
      priceWrapElement.prepend(paragraphElement);
    }

    const discountClass = +itemData.item_price_old > +itemData.item_price ? `product-page__price--discount` : ``;

    const itemPrice = productPageElement.querySelector(`.product-page__price`);
    if (discountClass) {
      itemPrice.classList.add(discountClass);
    }
    itemPrice.innerHTML = `${getFormattedPrice(itemData.item_price)} <span>&#8381;</span>`;

    const cartButtonWrapElement = productPageElement.querySelector(`.product-page__cartButtons`);
    cartButtonWrapElement.dataset.inCart = +itemData.item_cart > 0;

    const productCartButtonWrapElement = productPageElement.querySelector(`.product-page__cartButtonWrap`);

    const counterElement = createCounterElement(`product-page__counter counter`, itemData.item_cart, itemData.item_id, () => {
      cartButtonWrapElement.dataset.inCart = `true`;
    });
    productCartButtonWrapElement.append(counterElement);

    const addToCartButton = productPageElement.querySelector(`.product-page__addButton`);
    if (addToCartButton) {
      addToCartButton.addEventListener(`click`, () => {
        const addCounterButtonElement = counterElement.querySelector(`.counter__button--add`);

        addCounterButtonElement.click();
      });
    }

    if (shopInfoData.allow_change_price) {
      const changePrice = (price) => {
        if (!price) {
          return;
        }
        itemPrice.innerHTML = `${getFormattedPrice(price)} <span>&#8381;</span>`;
      };

      const incrementPriceButton = createButton(`+`, `product-page__incrementPriceButton button-secondary`);
      productPageElement.querySelector(`.product-page__priceContainer`).prepend(incrementPriceButton);

      incrementPriceButton.addEventListener(`click`, () => {
        setPriceInc(itemData.item_id, (response) => {
          changePrice(response.price);
        });
      });
    }

    const paramListElement = productPageElement.querySelector(`.product-page__paramList`);

    let deliveryText = ``;

    if (itemData.item_delivery === 0) {
      deliveryText = `<b>Самовывоз — бесплатно.</b> Оплата — при получении.`;
    }
    if (itemData.item_delivery === 1) {
      deliveryText = `<b>Доставка домой — в подарок.</b> Оплата — при получении.`;
    }
    const deliveryLiItemElement = createListItem(`product-page__paramItem`);
    paramListElement.append(deliveryLiItemElement);

    const deliveryParagraphElement = createParagraph(`product-page__param`, deliveryText);
    deliveryLiItemElement.append(deliveryParagraphElement);


    if (+itemData.item_credit) {
      const liItemElement = createListItem(`product-page__paramItem`);
      paramListElement.append(liItemElement);

      const paragraphElement = createParagraph(`product-page__param`, `от ${itemData.item_credit}&#8381; / месяц`);
      liItemElement.append(paragraphElement);
    }

    if (isInteger(itemData.item_store)) {
      if (+itemData.item_store) {
        const liItemElement = createListItem(`product-page__paramItem`);
        paramListElement.append(liItemElement);

        const paragraphElement = createParagraph(`product-page__param`, `В наличии в ${shopInfoData.town_p}, ${itemData.item_store} шт.`);
        liItemElement.append(paragraphElement);
      }
    } else {
      if (String(itemData.item_store) === `true`) {
        const liItemElement = createListItem(`product-page__paramItem`);
        paramListElement.append(liItemElement);

        const paragraphElement = createParagraph(`product-page__param`, `В наличии в ${shopInfoData.town_p}`);
        liItemElement.append(paragraphElement);
      }
    }

    if (itemData.item_date) {
      const liItemElement = createListItem(`product-page__paramItem`);
      paramListElement.append(liItemElement);

      const paragraphElement = createParagraph(`product-page__param`, `Склад, поступление ${itemData.item_date}`);
      liItemElement.append(paragraphElement);
    }

  } else {
    const notAvailableWrap = productPageElement.querySelector(`.product-page__notAvailable`);
    notAvailableWrap.classList.remove(`hide`);
  }

  new FavoritesController({
    className: `product-page`,
    itemId: itemData.item_id,
    isCheck: itemData.item_favorite,
    renderPosition: RenderPosition.AFTERBEGIN,
  }).render(productPageElement.querySelector(`.product-page__cartButtons`));

  if (!isEmptyObject(itemData.item_prop)) {
    const tableWrapElement = productPageElement.querySelector(`.product-page__tableWrap`);

    const propertiesComponent = new PropertyProductTableComponent({
      className: `product-page__table`,
      properties: Object.values(itemData.item_prop).filter((property) => property.main)
    });

    render(tableWrapElement, propertiesComponent.getElement(), RenderPosition.BEFOREEND);
  }

  const specItemDescription = productPageElement.querySelector(`.product-page__specItem--description`);
  if (itemData.item_descr) {
    specItemDescription.classList.remove(`hide`);
    const itemDescription = specItemDescription.querySelector(`.product-page__specContent`);
    const descriptionParagraphElement = createParagraph(``, itemData.item_descr);
    itemDescription.append(descriptionParagraphElement);
  } else {
    specItemDescription.remove();
  }

  const specItemPopularReview = productPageElement.querySelector(`.product-page__specItem--popularReview`);
  if (itemData.item_comment_pop && !isEmptyObject(itemData.item_comment_pop)) {
    specItemPopularReview.classList.remove(`hide`);
    const itemPopularReview = specItemPopularReview.querySelector(`.product-page__specContent`);
    renderReview(itemPopularReview, itemData.item_comment_pop);
  } else {
    specItemPopularReview.remove();
  }

  const navItemReviews = productPageElement.querySelector(`.product-page__navItem--reviews`);
  if (!isEmptyObject(itemData.item_comments)) {
    navItemReviews.classList.remove(`hide`);
    const commentNavTabElement = productPageElement.querySelector(`.product-page__navTab[data-spec="reviews"] span`);
    commentNavTabElement.textContent = itemData.item_comment_count;
  }

  if (!isEmptyObject(itemData.item_prop)) {
    // const parametersTableElement = productPageElement.querySelector(`.product-page__specContent--parameters table`);

    // Object.keys(itemData.item_prop)
    // .forEach((key) => {
    //   const tableRow = createTableRow(``, 2, [itemData.item_prop[key].title, itemData.item_prop[key].value]);
    //   parametersTableElement.append(tableRow);
    // });
    // ///

    const tableWrapElement = productPageElement.querySelector(`.product-page__specContent--parameters`);

    const propertiesComponent = new PropertyProductTableComponent({
      // className: `product-page__table`,
      properties: Object.values(itemData.item_prop)
    });

    render(tableWrapElement, propertiesComponent.getElement(), RenderPosition.AFTERBEGIN);
  }

  // оценки

  const rateElement = productPageElement.querySelector(`.product-page__wrapRate`);

  const ratingRateElement = rateElement.querySelector(`.rate__rating`);
  ratingRateElement.querySelector(`span`).innerHTML = itemData.item_rating;


  const reviewRateButtonElement = rateElement.querySelector(`.rate__review`);
  reviewRateButtonElement.innerHTML = getReviewNumeralEnding(itemData.item_comment_count);

  reviewRateButtonElement.addEventListener(`click`, () => {
    // аналог кнопки Показать все
    getData({
      [`get_item_comments`]: {
        [`item_id`]: itemData.item_id,
        [`start`]: 0,
      }
    })
    .then((itemData) => {
      if (itemData.result === `OK`) {
        showReviewsButton.remove();

        reviewsListElement.textContent = ``;

        const buttonElements = rateListElement.querySelectorAll(`.rate__button`);

        Array.from(buttonElements)
        .forEach((elem) => {
          elem.dataset.check = `false`;
        });

        Object.keys(itemData.item_comments).forEach((itemId) => {
          const review = itemData.item_comments[itemId];
          renderReviewItem(review);
        });
      }

      if (itemData.result === `ERROR`) {
        debugger;
      }
    });
  });

  const rateListElement = rateElement.querySelector(`.rate__list`);

  Object.keys(itemData.item_rate_list)
  .reverse()
  .forEach((rate) => {
    const liItemElement = createListItem(`rate__item`);
    rateListElement.append(liItemElement);

    const buttonElement = createButton(``, `rate__button`);
    liItemElement.append(buttonElement);

    const orderElement = createSpan(`rate__order`, rate);
    buttonElement.append(orderElement);

    const progressWrapElement = createDiv(`rate__progress`);
    buttonElement.append(progressWrapElement);

    const progressElement = createSpan();
    progressElement.style.width = `${Math.round(+itemData.item_rate_list[rate] / +itemData.item_comment_count * 100)}%`;
    progressWrapElement.append(progressElement);

    const countElement = createSpan(`rate__count`, itemData.item_rate_list[rate]);
    buttonElement.append(countElement);

    buttonElement.addEventListener(`click`, () => {
      buttonElement.dataset.check = buttonElement.dataset.check === `true` ? `false` : `true`;

      if (buttonElement.dataset.check === `true`) {
        const buttonElements = rateListElement.querySelectorAll(`.rate__button`);

        Array.from(buttonElements)
        .filter((elem) => elem !== buttonElement)
        .forEach((elem) => {
          elem.dataset.check = `false`;
        });

        // отправить запрос
        getData({
          [`get_item_comments`]: {
            [`item_id`]: itemData.item_id,
            [`rating`]: rate,
          }
        })
        .then((itemData) => {
          if (itemData.result === `OK`) {
            showReviewsButton.remove();
            reviewsListElement.textContent = ``;

            Object.keys(itemData.item_comments).forEach((itemId) => {
              const review = itemData.item_comments[itemId];
              renderReviewItem(review);
            });
          }

          if (itemData.result === `ERROR`) {
            debugger;
          }
        });
      }

      if (buttonElement.dataset.check === `false`) {
        getData({
          [`get_item_comments`]: {
            [`item_id`]: itemData.item_id,
            [`start`]: 0,
          }
        })
        .then((itemData) => {
          if (itemData.result === `OK`) {
            showReviewsButton.remove();

            reviewsListElement.textContent = ``;

            Object.keys(itemData.item_comments).forEach((itemId) => {
              const review = itemData.item_comments[itemId];
              renderReviewItem(review);
            });
          }

          if (itemData.result === `ERROR`) {
            debugger;
          }
        });
      }

    });

  });


  // отзывы
  const reviewsListElement = productPageElement.querySelector(`.reviews__list`);

  const renderReviewItem = (review) => {
    const liItemElement = createListItem(`reviews__item`);
    reviewsListElement.append(liItemElement);

    renderReview(liItemElement, review);
  };

  Object.keys(itemData.item_comments).forEach((itemId) => {
    const review = itemData.item_comments[itemId];
    renderReviewItem(review);
  });

  const showReviewsButton = productPageElement.querySelector(`.reviews__showButton`);
  if (Object.keys(itemData.item_comments).length >= +itemData.item_comment_count) {
    showReviewsButton.remove();
  } else {
    showReviewsButton.innerHTML = `Показать все ${itemData.item_comment_count} отзывов`;
  }

  showReviewsButton.addEventListener(`click`, () => {
    getData({
      [`get_item_comments`]: {
        [`item_id`]: itemData.item_id,
        [`start`]: Object.keys(itemData.item_comments).length,
      }
    })
    .then((itemData) => {
      if (itemData.result === `OK`) {
        showReviewsButton.remove();

        Object.keys(itemData.item_comments).forEach((itemId) => {
          const review = itemData.item_comments[itemId];
          renderReviewItem(review);
        });
      }

      if (itemData.result === `ERROR`) {
        debugger;
      }
    });
  });

  Object.values(additionList).forEach((addition) => {
    renderAccessories(productPageElement, `product-page`, addition);
  });
};
